import React, { useState } from 'react';

import { FontAwesomeIcon, Input } from '@appcharge/shared-ui';

interface IPasswordInputProps {
  label: string;
  value: string;
  onCopy: () => void;
}

export const PasswordInput: React.FC<IPasswordInputProps> = ({
  label,
  value,
  onCopy
}) => {
  const [showValue, setShowValue] = useState(false);

  const toggleVisibility = (): void => setShowValue(!showValue);

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <label className="text-sm font-medium text-gray-700">{label}</label>
        <FontAwesomeIcon
          icon="fa-regular fa-copy"
          className="cursor-pointer text-gray-500 transition-opacity hover:opacity-70"
          onClick={onCopy}
        />
      </div>
      <Input
        value={value}
        disabled
        type={showValue ? 'text' : 'password'}
        rightIcon={
          <FontAwesomeIcon
            icon={showValue ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'}
            onClick={toggleVisibility}
          />
        }
        rightIconStyles="cursor-pointer text-base-mutedForeground"
      />
    </div>
  );
};

